import React, {useEffect} from 'react'

import './WhyUs.scss'
import ScaleIcon from '../../assets/scale_icon.svg'
import MoneyIcon from '../../assets/money_icon.svg'
import ChatIcon from '../../assets/chat_icon.svg'
import ScalabilityIcon from '../../assets/scalability_icon.svg'
import { useInView } from 'react-intersection-observer';
import { useInViewOptions } from '../../utils/constants';
import { removeSelectedNavItem, selectActiveItemOnNav } from '../../utils/functions';

const WhyUs = () => {

const { ref, inView, entry } = useInView(useInViewOptions);

  useEffect(() => { 
      if (inView)  {
          selectActiveItemOnNav('aboutus');
      } else removeSelectedNavItem('aboutus');
  }, [inView]);

  return (
    <section ref={ref}>
        <div className='container'>
            <h1 className='section__heading'>About Us</h1>

            <p className='whyus__description'>At Adeptech, we're not just software developers, we're problem solvers. We work with businesses to identify and address their unique challenges, delivering customized software solutions that help them achieve their goals. From mobile and web applications to software systems, our team of skilled developers is committed to delivering high quality software that exceeds expectations.</p>

            <div className="reasons__container">
                
                <div className="reason">
                    <img src={ScaleIcon} alt="Goal Icon"/>
                    <article>Industry best skills at competitive rates</article>
                </div>
                <div className="reason">
                    <img src={MoneyIcon} alt="Search Icon" />
                    <article>No hidden costs</article>
                </div>
                <div className="reason">
                    <img src={ChatIcon} alt="Chat Icon" />
                    <article>Transparent communication</article>
                </div>
                <div className="reason">
                    <img src={ScalabilityIcon} alt="Chat Icon" />
                    <article>Focused on scalability and efficiency</article>
                </div>

            </div>

        </div>
    </section>
  )
}

export default WhyUs